import { render } from "./ClaimSuccess.vue?vue&type=template&id=3c075276&scoped=true&ts=true"
import script from "./ClaimSuccess.vue?vue&type=script&lang=ts"
export * from "./ClaimSuccess.vue?vue&type=script&lang=ts"

import "./ClaimSuccess.vue?vue&type=style&index=0&id=3c075276&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c075276"]])

export default __exports__